module.exports = __webpack_public_path__ + "static/media/Cl.af59a73c.png";